module.exports = __webpack_public_path__ + "img/c3.0c755540.jpg";